import React, { useState, useEffect } from 'react';
import { PiPencilBold } from "react-icons/pi";
import { MdOutlineMailOutline } from "react-icons/md";
import { MdOutlinePhoneIphone } from "react-icons/md";
import { MdHouse } from "react-icons/md";
import { FaRegCalendar } from "react-icons/fa";
import { MdOutlineLocationSearching } from "react-icons/md";
import { BsSignpost2Fill } from "react-icons/bs";
import { IoMdBusiness } from "react-icons/io";
import { MdLocationCity } from "react-icons/md";
import { MdOutlineBadge } from "react-icons/md";
import { MdApartment } from "react-icons/md";
import { MdCorporateFare } from "react-icons/md";
import { useParams } from "react-router-dom";
import { useGetUserWithPermissionsQuery, useUpdateUserMutation, useUpdateStaffPermissionsMutation } from "../../services/userCRUDApi";
import { Alert, CircularProgress } from "@mui/material";

const MemberEdit = () => {
  const { id } = useParams();
  const { data: responseData, isLoading: responseLoading, refetch: refetchUser } = useGetUserWithPermissionsQuery(id);
  const [updateUser, { isLoading }] = useUpdateUserMutation();
  const [updatePermissions] = useUpdateStaffPermissionsMutation();
  const [data, setData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    houseNumber: '',
    street: '',
    area: '',
    city: '',
    companyName: '',
    companySize: '',
    vatNumber: '',
    companyCity: '',
    companyArea: '',
    companyStreet: '',
    companyPostalCode: '',
    newPassword: '',
    repeatPassword: '',
    is_active: true,
    email: '',
    data_Joind: '',
    last_login: '',
    type: ''
  });
  const [success, setSuccess] = useState(false);
  const [server_error, setServerError] = useState({});
  const [allowedPages, setAllowedPages] = useState([]);

  useEffect(() => {
    if (responseData) {
      const userData = responseData;
      console.log("Fetched user data:", userData); // Debug log
      console.log("Staff permissions:", userData.staff_permissions); // Debug log

      setData({
        id: userData.id,
        firstName: userData.first_Name || '',
        lastName: userData.last_Name || '',
        phone: userData.phone_Number || '',
        data_Joind: userData.data_Joind || '',
        email: userData.email || '',
        last_login: userData.last_login || '',
        type: userData.type || '',
        companyName: userData.company_name || '',
        companySize: userData.company_size || '',
        vatNumber: userData.Vat_number || '',
        is_active: userData.is_active || true,
        // Address
        houseNumber: userData.address?.house_Number || '',
        street: userData.address?.street_Number || '',
        city: userData.address?.city || '',
        area: userData.address?.area || '',
        // Company Address
        companyCity: userData.company_address?.city || '',
        companyArea: userData.company_address?.area || '',
        companyStreet: userData.company_address?.street_Number || '',
        companyPostalCode: userData.company_address?.postal_code || '',
        newPassword: '',
        repeatPassword: ''
      });

      // FIXED: Properly handle staff permissions
      const pages = userData.staff_permissions?.allowed_pages || [];
      console.log("Setting allowed pages:", pages); // Debug log
      setAllowedPages(pages);
    }
  }, [responseData]);

  // Handle Input Changes
  const handleInputChange = (field, value) => {
    setData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Handle Submit
  const handleSubmit = async (event) => {
    event.preventDefault();
    const actualData = {
      id: data.id,
      first_Name: data.firstName,
      last_Name: data.lastName,
      phone_Number: data.phone,
      type: data.type,
      company_name: data.companyName,
      company_size: data.companySize,
      Vat_number: data.vatNumber,
      is_active: data.is_active,
      // Address
      address_Id: responseData.address?.address_Id,
      address: {
        house_Number: data.houseNumber,
        street_Number: data.street,
        city: data.city,
        area: data.area,
      },
      // Company Address
      company_address: {
        city: data.companyCity || "",
        area: data.companyArea || "",
        street_Number: data.companyStreet || "",
        postal_code: data.companyPostalCode || "",
      },
      password: data.newPassword,
      repeat_password: data.repeatPassword,
    };
    console.log("Submitting data:", actualData);
    try {
      const res = await updateUser(actualData);
      if (res.error) {
        console.error("Update error:", res.error);
        if (res.error.data) {
          setServerError(
            res.error.data.errors || { general: res.error.data.message }
          );
        } else {
          setServerError({ general: "Update failed. Please try again." });
        }
      } else if (res.data) {
        console.log("Update success:", res.data);
        setSuccess(true);
        setServerError({});
        setData((prev) => ({ ...prev, newPassword: "", repeatPassword: "" }));
        // Refresh user data to get updated information
        refetchUser();
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      setServerError({ general: "An unexpected error occurred." });
    }
  };

  const pagePermissions = [
    { key: "dashboard", label: "Dashboard" },
    { key: "orders", label: "Orders" },
    { key: "place-orders", label: "Place Orders"},
    { key: "monthly-invoices", label: "Statements" },
    { key: "posting", label: "Postings" },
    { key: "customers", label: "Customers" },
    { key: "inactive", label: "Inactive Customers" },
    { key: "staff", label: "Members" },
    { key: "staf", label: "Staff Members" },
    { key: "category", label: "Categories" },
    { key: "products", label: "Products" },
    { key: "feedbacks", label: "Reviews" },
    { key: "question", label: "Messages" },
    { key: "expenses-uk", label: "Hira Tech UK Expense" },
    { key: "lot", label: "Lot Tracking Record" },
    { key: "profile", label: "Profile" },
    { key: "currency", label: "Currency Settings" },
  ];

  const handlePageToggle = (pageKey) => {
    setAllowedPages(prev =>
      prev.includes(pageKey)
        ? prev.filter(p => p !== pageKey)
        : [...prev, pageKey]
    );
  };

  const handleSavePermissions = async () => {
    try {
      const result = await updatePermissions({ id, allowed_pages: allowedPages }).unwrap();
      console.log("Permissions saved:", result); // Debug log
      setSuccess(true);
      // Refresh user data to get updated permissions
      refetchUser();
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error("Error saving permissions:", err);
      setServerError({ general: "Failed to save permissions" });
    }
  };

  // City options array
  const cityOptions = [
    "Select City",
    "Aberdeen City",
    "Aberdeenshire",
    "Abertaw GB-ATA",
    "Angus",
    "Antrim",
    "Ards",
    "Argyll and Bute",
    "Armagh",
    "Ballymena",
    "Ballymoney",
    "Banbridge",
    "Barking and Dagenham",
    "Barnet",
    "Barnsley",
    "Bath and North East Somerset",
    "Bedfordshire",
    "Belfast",
    "Bexley",
    "Birmingham",
    "Blackburn with Darwen",
    "Blackpool",
    "Blaenau Gwent",
    "Bolton",
    "Borders Region",
    "Bournemouth",
    "Bracknell Forest",
    "Bradford",
    "Brent",
    "Brighton and Hove",
    "Bristol",
    "Bromley",
    "Bro Morgannwg GB-BMG",
    "Buckinghamshire",
    "Bury",
    "Caerdydd GB-CRD",
    "Caerffili GB-CAF",
    "Camden",
    "Carrickfergus",
    "Casnewydd GB-CNW",
    "Castell-nedd Port Talbot GB-CTL",
    "Castlereagh",
    "Cheshire",
    "Clackmannanshire",
    "Coleraine",
    "Conwy",
    "Cookstown",
    "Cornwall",
    "Coventry",
    "Craigavon",
    "Croydon",
    "Cumbria",
    "Darlington",
    "Derby",
    "Derbyshire",
    "Derry",
    "Devon",
    "Doncaster",
    "Dorset",
    "Down",
    "Dudley",
    "Dumfries and Galloway",
    "Dundee City",
    "Dungannon",
    "Durham",
    "Ealing",
    "East Ayrshire",
    "East Dunbartonshire",
    "East Lothian",
    "East Renfrewshire",
    "East Riding of Yorkshire",
    "East Sussex",
    "Edinburg",
    "Eilean Siar",
    "Enfield",
    "Essex",
    "Falkirk",
    "Farmanagh",
    "Fife",
    "Gateshead",
    "Glasgow City",
    "Gloucestershire",
    "Greenwich",
    "Gwynedd",
    "Hackney",
    "Halton",
    "Hammersmith and Fulham",
    "Hampshire",
    "Haringey",
    "Harrow",
    "Hartlepool",
    "Havering",
    "Herefordshir",
    "Hertfordshire",
    "Highland",
    "Hillingdon",
    "Hounslow",
    "Inverclyde",
    "Isle of Wight",
    "Isles of Scilly",
    "Islington",
    "Kensingaton and Chelsea",
    "Kent",
    "Kingston upon Hul",
    "Kington upon Thame",
    "Kirkless",
    "Knowsley",
    "Lambeth",
    "Lancashire",
    "Larne",
    "Leeds",
    "Leicester",
    "Leicestershire",
    "Lewishem",
    "Limavady",
    "Lincolnshire",
    "Lisburn",
    "Liverpool",
    "London",
    "Luton",
    "Magherafelt",
    "Manchester",
    "Medway",
    "Merthyr Thudful GB-MTU",
    "Merton",
    "Middlesbrough",
    "Midlothian",
    "Milton Keynes",
    "Moray",
    "Moyle",
    "Newcastle upon Tyne",
    "Newham",
    "Newry and Mourne",
    "Newtownabbey",
    "Norfolk",
    "Northamptonshire",
    "North Ayshire",
    "North Down",
    "North East Lincolnshire",
    "North Lanarkshire",
    "North Lincolnshire",
    "North Somerset",
    "North Tyneside",
    "Northhumberland",
    "North Yorkshire",
    "Nottingham",
    "Nottinghamshire",
    "Oldham",
    "Omagh",
    "Orkney Islands",
    "Oxfordshire",
    "Pen-y-bont or Ogwr GB-POG",
    "Perth and Kinross",
    "Peterborough",
    "Plymouth",
    "Poole",
    "Portsmouth",
    "Powys",
    "Reading",
    "Redbridge",
    "Redcar and Cleveland",
    "Renfrewshire",
    "Rhondd",
    "Richmond upon Thames",
    "Rochdale",
    "Rotherham",
    "Rutland",
    "Salford",
    "Sandwell",
    "Scottish Border",
    "Sefton",
    "Sheffield",
    "Shetland Islands",
    "Shropshire",
    "Sir Benfro GB-BNF",
    "Sir Ceredigion",
    "Sir Ddinbych GB-DDB",
    "Sir Fynwy GB-FYN",
    "Sir Gaerfyrddin GB-GFY",
    "Sir y Fflint GB-FFL",
    "Sir Ynys Mon GB-YNM",
    "Slough",
    "Solihull",
    "Somerset",
    "Southampton",
    "South Ayrshire",
    "Southend-on-Sea",
    "South Gloucestershire",
    "South Lanarkshire",
    "South Tyneside",
    "Southwark",
    "St. Helens",
    "Staffordshire",
    "Stirling",
    "Stockport",
    "Stockton-on-Tees",
    "Stoke-on-Trent",
    "Strabane",
    "Suffolk",
    "Sunderland",
    "Surrey",
    "Sutton",
    "Swindon",
    "Tameside",
    "Telford and Wrekin",
    "Thurrock",
    "Tor-faen",
    "Torbay",
    "Tower Hamlets",
    "Trafford",
    "Wakefield",
    "Walsall",
    "Waltham Forest",
    "Wandsworth",
    "Warrington",
    "Warwickshire",
    "West Berkshire",
    "West Dunbartonshire",
    "West Lothian",
    "Westminster",
    "Wigan",
    "Wiltshire",
    "Windsor and Maidenhead",
    "Wirral",
    "Wokingham",
    "Wolverhampton",
    "Worcestershire",
    "Wrexham",
    "York"
  ];

  // If fetching is loading, show spinner
  if (responseLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1>
        User Profile
      </h1>
      {/* Success and Error Messages */}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Profile Data Updated Successfully
        </Alert>
      )}
      {server_error.general && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {server_error.general}
        </Alert>
      )}
      {Object.keys(server_error).map(
        (key) =>
          key !== "general" && (
            <Alert key={key} severity="error" sx={{ mb: 2 }}>
              {key}: {server_error[key]}
            </Alert>
          )
      )}
      <div style={{
        display: 'flex',
        gap: '30px',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        {/* ====================== LEFT COLUMN ====================== */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '30px',
          flex: '1',
          minWidth: '300px',
          maxWidth: '500px'
        }}>
          {/* USER PROFILE CARD */}
          <div style={{
            backgroundColor: '#fff',
            padding: '25px',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}>
            {/* Profile Header */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                backgroundColor: '#004aad',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '15px'
              }}>
                <span style={{ color: '#fff', fontSize: '24px', fontWeight: 'bold' }}>
                  {data.firstName ? data.firstName.charAt(0).toUpperCase() : 'M'}
                </span>
              </div>
              <div>
                <div style={{ fontSize: '18px', marginBottom: '5px' }}>
                  <span style={{ color: '#004aad' }}>First Name: </span>
                  <span style={{ color: '#333' }}>{data.firstName}</span>
                </div>

                <div style={{ fontSize: '16px', marginBottom: '5px' }}>
                  <span style={{ color: '#004aad' }}>Last Name: </span>
                  <span style={{ color: '#333' }}>{data.lastName}</span>
                </div>

                <div style={{ fontSize: '14px' }}>
                  <span style={{ color: '#004aad', fontSize: '16px' }}>User Type: </span>
                  {data.type}
                </div>
              </div>
            </div>
            {/* Account Status Toggle */}
            <h3 style={{ color: '#004aad', margin: '20px 0 10px', fontSize: '18px' }}>Account Status</h3>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <span style={{
                marginRight: '10px',
                color: data.is_active ? '#666' : '#666',
                fontWeight: data.is_active ? 'normal' : 'normal'
              }}>
                Inactive
              </span>
              <div
                onClick={() => handleInputChange('is_active', !data.is_active)}
                style={{
                  width: '50px',
                  height: '25px',
                  backgroundColor: data.is_active ? '#004aad' : '#ccc',
                  borderRadius: '25px',
                  position: 'relative',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s'
                }}
              >
                <div style={{
                  width: '21px',
                  height: '21px',
                  backgroundColor: '#fff',
                  borderRadius: '50%',
                  position: 'absolute',
                  top: '2px',
                  left: data.is_active ? '27px' : '2px',
                  transition: 'left 0.3s'
                }}></div>
              </div>
              <span style={{
                marginLeft: '10px',
                color: data.is_active ? '#666' : '#666',
                fontWeight: data.is_active ? 'normal' : 'normal'
              }}>
                Active
              </span>
            </div>
            {/* Account Status + Email */}
            <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '18px', color: '#004aad' }}><MdOutlineMailOutline />Account Status:</span>
              <strong style={{ color: data.is_active ? '#33902F' : 'red' }}>
                {data.is_active ? 'Active' : 'Inactive'}
              </strong>
              <span style={{ marginLeft: '10px', color: '#004aad' }}>Email: </span>
              <span>{data.email}</span>
            </div>
            {/* Other Info */}
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '18px', color: '#004aad' }}><MdOutlinePhoneIphone />Phone:</span> {data.phone}
            </div>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '18px', color: '#004aad' }}><FaRegCalendar />Joined:</span> {data.data_Joind}
            </div>
            <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '18px', color: '#004aad' }}><FaRegCalendar />Last Login:</span> {data.last_login}
            </div>
            {/* Address & Company */}
            <h3 style={{ color: '#004aad', margin: '20px 0 10px', fontSize: '18px' }}>Address Details</h3>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '18px', color: '#004aad' }}><MdHouse />House Number:</span> {data.houseNumber}
            </div>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '18px', color: '#004aad' }}><BsSignpost2Fill />Street:</span> {data.street}
            </div>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '18px', color: '#004aad' }}><MdOutlineLocationSearching />Area: </span> {data.area}
            </div>
            <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '18px', color: '#004aad' }}><MdLocationCity />City: </span> {data.city}
            </div>
            <h3 style={{ color: '#004aad', margin: '20px 0 10px', fontSize: '18px' }}>Company Details</h3>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '18px', color: '#004aad' }}><IoMdBusiness />Company Name:</span> {data.companyName || '-'}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '18px', color: '#004aad' }}><MdOutlineBadge />Company Size:</span> {data.companySize || '-'}
            </div>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '16px', color: '#004aad' }}><MdOutlineBadge />VAT Number:</span> {data.vatNumber || '-'}
            </div>
            {/* Company Address Section */}
            <h3 style={{ color: '#004aad', margin: '20px 0 10px', fontSize: '18px' }}>Company Address</h3>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '16px', color: '#004aad' }}><MdLocationCity />Company City:</span> {data.companyCity || '-'}
            </div>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '16px', color: '#004aad' }}><MdApartment />Company Area:</span> {data.companyArea || '-'}
            </div>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '16px', color: '#004aad' }}><BsSignpost2Fill />Company Street:</span> {data.companyStreet || '-'}
            </div>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px', fontSize: '16px', color: '#004aad' }}><MdCorporateFare />Postal Code:</span> {data.companyPostalCode}
            </div>
          </div>
          {/* PERMISSIONS SECTION - SEPARATE CARD ON LEFT SIDE */}
          <div>
            <h1 style={{color:"#004aad",marginBottom:"10px"}} >
              Permissions
            </h1>
          </div>
          <div style={{backgroundColor:'#f4f4f4',padding:'1px',borderTop:'2px solid #004aad'}}>
            <div style={{ backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '8px' }}>
              <h3 style={{ color: '#004aad', marginBottom: '15px' }}>Assign Pages (Visible in Sidebar)</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px' }}>
                {pagePermissions.map(page => (
                  <label key={page.key} style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                    <input
                      type="checkbox"
                      checked={allowedPages.includes(page.key)}
                      onChange={() => handlePageToggle(page.key)}
                      style={{ marginRight: '8px' }}
                    />
                    {page.label}
                  </label>
                ))}
              </div>
              <button onClick={handleSavePermissions} style={saveButtonStyle}>
                <PiPencilBold /> Save Permissions
              </button>
            </div>
          </div>
        </div>
        {/* ====================== RIGHT: EDIT FORM ====================== */}
        <div style={{
          flex: '1',
          minWidth: '300px',
          maxWidth: '550px',
          backgroundColor: '#fff',
          padding: '20px',
          border: '1px solid #ddd',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0, color: '#004aad' }}>Edit</h2>
            </div>
            <h3 style={{ color: '#004aad', margin: '20px 0 10px' }}>Personal Details</h3>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>First Name</label>
              <input
                type="text"
                value={data.firstName}
                onChange={(e) => handleInputChange('firstName', e.target.value)}
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Last Name</label>
              <input
                type="text"
                value={data.lastName}
                onChange={(e) => handleInputChange('lastName', e.target.value)}
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Phone Number</label>
              <input
                type="text"
                value={data.phone}
                onChange={(e) => handleInputChange('phone', e.target.value)}
                style={inputStyle}
              />
            </div>
            <h3 style={{ color: '#004aad', margin: '20px 0 10px' }}>Address Details</h3>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>House Number</label>
              <input
                type="text"
                value={data.houseNumber}
                onChange={(e) => handleInputChange('houseNumber', e.target.value)}
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Street</label>
              <input
                type="text"
                value={data.street}
                onChange={(e) => handleInputChange('street', e.target.value)}
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Area</label>
              <input
                type="text"
                value={data.area}
                onChange={(e) => handleInputChange('area', e.target.value)}
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>City</label>
              <select
                value={data.city}
                onChange={(e) => handleInputChange('city', e.target.value)}
                style={inputStyle}
              >
                {cityOptions.map((city, index) => (
                  <option key={index} value={city}>
                    {city}
                  </option>
                ))}
              </select>
            </div>
            <h3 style={{ color: '#004aad', margin: '20px 0 10px' }}>Company Details</h3>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Company Name</label>
              <input
                type="text"
                value={data.companyName}
                onChange={(e) => handleInputChange('companyName', e.target.value)}
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Company Size</label>
              <input
                type="text"
                value={data.companySize}
                onChange={(e) => handleInputChange('companySize', e.target.value)}
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>VAT Number</label>
              <input
                type="text"
                value={data.vatNumber}
                onChange={(e) => handleInputChange('vatNumber', e.target.value)}
                style={inputStyle}
              />
            </div>
            <h3 style={{ color: '#004aad', margin: '20px 0 10px' }}>Company Address</h3>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Company City</label>
              <select
                value={data.companyCity}
                onChange={(e) => handleInputChange('companyCity', e.target.value)}
                style={inputStyle}
              >
                {cityOptions.map((city, index) => (
                  <option key={index} value={city}>
                    {city}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Company Area</label>
              <input
                type="text"
                value={data.companyArea}
                onChange={(e) => handleInputChange('companyArea', e.target.value)}
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Company Street</label>
              <input
                type="text"
                value={data.companyStreet}
                onChange={(e) => handleInputChange('companyStreet', e.target.value)}
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Company Postal Code</label>
              <input
                type="text"
                value={data.companyPostalCode}
                onChange={(e) => handleInputChange('companyPostalCode', e.target.value)}
                style={{ ...inputStyle, backgroundColor: '#f0f8ff' }}
              />
            </div>
            <h3 style={{ color: '#004aad', margin: '20px 0 10px' }}>Password</h3>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>New Password</label>
              <input
                type="password"
                value={data.newPassword}
                onChange={(e) => handleInputChange('newPassword', e.target.value)}
                placeholder="Leave blank to keep current"
                style={{ ...inputStyle, backgroundColor: '#f0f8ff' }}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={labelStyle}>Repeat Password</label>
              <input
                type="password"
                value={data.repeatPassword}
                onChange={(e) => handleInputChange('repeatPassword', e.target.value)}
                style={{ ...inputStyle, backgroundColor: '#f0f8ff' }}
              />
            </div>
            <div style={{ textAlign: 'right', marginTop: '20px' }}>
              {isLoading ? (
                <CircularProgress />
              ) : (
                <button
                  type="submit"
                  style={updateButtonStyle}
                >
                  Update
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// Styles
const checkboxStyle = {
  width: '16px',
  height: '16px',
  cursor: 'pointer'
};
const labelStyle = {
  display: 'block',
  marginBottom: '5px',
  fontWeight: 'bold',
  fontSize: '14px'
};
const inputStyle = {
  width: '100%',
  padding: '8px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  fontSize: '14px'
};
const updateButtonStyle = {
  backgroundColor: '#004aad',
  color: '#fff',
  padding: '10px 20px',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  fontWeight: 'bold',
  fontSize: '16px'
};
const saveButtonStyle = {
  backgroundColor: '#004aad',
  color: 'white',
  padding: '8px 16px',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontWeight: 'bold',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginTop: '15px'
};

export default MemberEdit;

